<template>
    <div class="link-info">
        <div class="link-info__container" v-if="!isMobile || !showMerchantName">
            <div class="link-info__identification">
                <MerchantLogo v-if="!isCustomizationEnabled" />

                <div class="link-info__identification-detail">
                    <p tabindex="0">
                        {{ merchantName }}
                    </p>
                    <small tabindex="0" v-text="$ml.get('linkInfo')" />
                </div>
            </div>

            <hr class="link-info__divider" />
        </div>
        <TotalOverview
            style="border-radius: 12px;"
            :is-mobile="isMobile"
            :show-merchant-name="showMerchantName"
        />
    </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';

  import TotalOverview from '@/components/TotalOverview';
  import MerchantLogo from '@/components/MerchantLogo';

  export default {

      components: {
          TotalOverview,
          MerchantLogo
      },

      props: {
          isMobile: {
              type: Boolean,
              default: false
          },
          showMerchantName: {
              type: Boolean,
              default: true
          }
      },

      computed: {
          ...mapGetters({
              formattedPrice: 'payment/getFormattedPrice'
          }),
          ...mapState({
              isCustomizationEnabled: state => state.merchantLayout.IsCustomizationEnabled,
              merchantName: state => state.preorder.MerchantName,
          }),
      }
  };
</script>

<style lang="scss" scoped>
  .link-info {
      background: #EFF1F3;
      padding: 0 16px;
      
      @media screen and (min-width: 1025px) {
          border-radius: 12px;
          padding: 0;
      }
      
      &__container {
        padding: 16px 0 0;
        
        @media screen and (min-width: 1025px) {
          padding: 24px 24px 0;
        }
      }

      &__identification {
        display: flex;
        align-items: center;

        .merchant-logo {
            margin-right: 16px;
        }
      }

      &__identification-detail {
          display: flex;
          flex-direction: column;

          p {
            font-size: 16px;
            line-height: 16px;
            font-weight: 600;
            color: #000;

            margin-bottom: 12px;
          }

          small {
            font-size: 12px;
            font-weight: 500;
            line-height: 12px;
            color: #000;
          }
      }

      &__divider {
          border-color: #B8C1CC;
          margin: 16px 0 0;
      }
  }
</style>
